var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 187,
    viewBox: "0 0 178 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 130.131C133.511 130.131 170 142.849 170 158.538C170 174.227 133.511 186.945 88.5 186.945C43.4888 186.945 7 174.227 7 158.538C7 142.849 43.4888 130.131 88.5 130.131ZM88.5 176.188C116.466 176.188 139.137 168.285 139.137 158.538C139.137 148.79 116.466 140.888 88.5 140.888C60.5338 140.888 37.8627 148.79 37.8627 158.538C37.8627 168.285 60.5338 176.188 88.5 176.188Z",
    fill: "url(#paint0_linear_3046_255708)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9987 89L19.6289 48.9497L88.9966 8.90002L158.366 48.9507L88.9987 89Z",
    fill: "#FCE9CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2368 69.508L53.3906 68.4421L122.758 28.3925L124.604 29.458L55.2368 69.508Z",
    fill: "#F5B500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.1862 72.3663L48.4375 65.5831L117.805 25.5338L129.554 32.317L60.1862 72.3663Z",
    fill: "#FFFDF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9991 169.1L19.6289 129.049V48.9504L88.9991 89.0008V169.1Z",
    fill: "#FCE9CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.1908 72.3749V80.7964L58.7052 81.5771L57.2424 79.0944L55.7572 79.8751L54.294 77.392L52.8305 78.1855L51.3677 75.7028L49.9046 76.4963L48.4414 74.0129V65.5917L60.1908 72.3749Z",
    fill: "#FFFDF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.369 129.049L89 169.1V89.0008L158.369 48.9504V129.049Z",
    fill: "#F8D08D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.913 69.0847L135.717 79.0132C134.919 79.4742 134.27 79.099 134.27 78.1773V69.6707C134.27 68.7494 134.919 67.6244 135.717 67.1638L152.913 57.2356C153.712 56.7746 154.361 57.1498 154.361 58.0708V66.5778C154.361 67.4991 153.712 68.6241 152.913 69.0847ZM135.717 67.9965C135.317 68.2279 134.991 68.7918 134.991 69.2542V77.7608C134.991 78.2236 135.317 78.4116 135.717 78.1798L152.914 68.2517C153.314 68.0207 153.64 67.4564 153.64 66.9943V58.4873C153.64 58.0249 153.314 57.8369 152.914 58.0683L135.717 67.9965Z",
    fill: "#F5B500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.043 76.3468L136.133 76.8723V68.8242L137.043 68.2987V76.3468Z",
    fill: "#F5B500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.195 69.9078L147.285 70.4326V62.3848L148.195 61.8594V69.9078Z",
    fill: "#F5B500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.814 75.3254L137.5 76.0844V68.0363L138.814 67.277V75.3254Z",
    fill: "#F5B500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.881 70.6671L145.566 71.4261V63.378L146.881 62.619V70.6671Z",
    fill: "#F5B500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.394 68.0619L150.484 68.5874V60.5396L151.394 60.0142V68.0619Z",
    fill: "#F5B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.076 68.822L148.762 69.5814V61.5329L150.076 60.7743V68.822Z",
    fill: "#F5B500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.921 72.3766L141.949 73.5154V65.4673L143.921 64.3289V72.3766Z",
    fill: "#F5B500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.076 74.5952L139.418 74.9751V66.9266L140.076 66.5475V74.5952Z",
    fill: "#F5B500"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M152.497 67.4243L151.84 67.8038V59.7561L152.497 59.3762V67.4243Z",
    fill: "#F5B500"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.341 73.8658L140.684 74.2453V66.1969L141.341 65.8174V73.8658Z",
    fill: "#F5B500"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.142 71.6714L144.484 72.0505V64.0028L145.142 63.6229V71.6714Z",
    fill: "#F5B500"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5265 153.736C99.4984 153.425 99.2559 153.309 98.9647 153.477C98.7857 153.581 98.6262 153.769 98.5226 153.978C98.4603 154.105 98.3392 154.174 98.2769 154.12C98.1737 154.03 98.0142 154.026 97.8355 154.129C97.6564 154.232 97.4969 154.421 97.3934 154.63C97.3311 154.757 97.21 154.826 97.1484 154.772C97.0448 154.682 96.8857 154.678 96.7066 154.781C96.5276 154.884 96.3681 155.073 96.2648 155.282C96.2022 155.409 96.0815 155.478 96.0195 155.424C95.916 155.334 95.7568 155.33 95.5778 155.433C95.2862 155.601 95.0445 155.997 95.0156 156.341C95.0466 154.915 96.0445 153.208 97.2712 152.499C98.498 151.791 99.4959 152.346 99.5265 153.736Z",
    fill: "#F5B500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8334 157.995C97.3802 158.257 97.0117 158.044 97.0117 157.521V153.952L97.5272 153.654V157.223C97.5272 157.418 97.6646 157.497 97.8334 157.399C98.0018 157.302 98.1392 157.064 98.1392 156.87L98.655 156.572C98.655 157.095 98.2862 157.734 97.8334 157.995Z",
    fill: "#F5B500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7724 157.99L94.7684 160.879C94.2262 161.192 93.7852 160.938 93.7852 160.311V154.534C93.7852 153.907 94.2262 153.143 94.7684 152.831L99.7724 149.942C100.314 149.628 100.755 149.883 100.755 150.509V156.287C100.755 156.913 100.314 157.677 99.7724 157.99ZM94.7684 153.396C94.4961 153.553 94.275 153.937 94.275 154.251V160.028C94.275 160.342 94.4961 160.47 94.7684 160.313L99.7724 157.424C100.044 157.267 100.265 156.884 100.265 156.57V150.792C100.265 150.478 100.044 150.35 99.7724 150.507L94.7684 153.396Z",
    fill: "#F5B500"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.292 149.056C105.219 149.02 105.104 149.09 105.034 149.21L104.567 150.016L103.84 149.593C104.508 148.529 105.227 149.01 105.292 149.056Z",
    fill: "#F5B500"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.485 148.06L105.755 149.323L105.297 149.058C105.297 149.058 105.294 149.057 105.292 149.055C105.227 149.009 104.508 148.529 103.84 149.593L104.304 148.789C104.779 147.967 105.552 147.521 106.026 147.795L106.485 148.06Z",
    fill: "#F5B500"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.829 149.011L105.379 149.848L106.829 147.337V149.011Z",
    fill: "#F5B500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.675 152.249C103.653 152.373 103.713 152.452 103.809 152.427L104.444 152.259L104.176 153.562C103.332 153.72 103.645 152.373 103.675 152.249Z",
    fill: "#F5B500"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.85 151.686L103.846 151.419L103.679 152.24C103.679 152.24 103.678 152.244 103.677 152.249C103.647 152.373 103.334 153.72 104.177 153.562L103.543 153.732C102.895 153.906 102.509 153.356 102.682 152.508L102.85 151.686Z",
    fill: "#F5B500"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.541 150.369L104.265 151.4L102.285 151.931L103.541 150.369Z",
    fill: "#F5B500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.181 151.287C106.275 151.199 106.331 151.049 106.305 150.954L106.137 150.318L107.132 149.437C107.307 150.343 106.275 151.21 106.181 151.287Z",
    fill: "#F5B500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.814 152.845L105.547 151.849L106.174 151.293C106.174 151.293 106.177 151.29 106.181 151.287C106.276 151.21 107.307 150.343 107.132 149.437L107.302 150.071C107.476 150.719 107.089 151.716 106.441 152.29L105.814 152.845Z",
    fill: "#F5B500"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.781 153.212L105.506 151.344L106.037 153.324L104.781 153.212Z",
    fill: "#F5B500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.315 153.636L102.311 156.525C101.769 156.838 101.328 156.583 101.328 155.958V150.18C101.328 149.553 101.769 148.789 102.311 148.477L107.315 145.587C107.857 145.274 108.298 145.529 108.298 146.155V151.933C108.298 152.56 107.857 153.323 107.315 153.636ZM102.311 149.042C102.039 149.199 101.818 149.583 101.818 149.897V155.675C101.818 155.989 102.039 156.117 102.311 155.96L107.315 153.071C107.587 152.914 107.808 152.53 107.808 152.216V146.438C107.808 146.125 107.587 145.997 107.315 146.153L102.311 149.042Z",
    fill: "#F5B500"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.314 149.348L110.59 149.766V146.032L111.314 145.613V149.348Z",
    fill: "#F5B500"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.502 147.507V148.344L110 150.943V150.106L114.502 147.507Z",
    fill: "#F5B500"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.916 147.848L113.191 148.266V144.531L113.916 144.113V147.848Z",
    fill: "#F5B500"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M112.14 145.316L109.766 146.688L110.953 144.631L112.14 145.316Z",
    fill: "#F5B500"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.738 143.817L112.363 145.188L113.551 143.131L114.738 143.817Z",
    fill: "#F5B500"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.753 149.342L109.749 152.231C109.207 152.544 108.766 152.289 108.766 151.664V145.886C108.766 145.26 109.207 144.495 109.749 144.183L114.753 141.293C115.295 140.98 115.736 141.235 115.736 141.861V147.639C115.736 148.265 115.295 149.029 114.753 149.342ZM109.749 144.748C109.477 144.906 109.256 145.289 109.256 145.602V151.381C109.256 151.695 109.477 151.822 109.749 151.666L114.753 148.776C115.025 148.62 115.246 148.236 115.246 147.922V142.144C115.246 141.83 115.025 141.702 114.753 141.859L109.749 144.748Z",
    fill: "#F5B500"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.877 142.391C120.856 141.654 121.62 139.759 121.62 138.601L117.754 140.833C117.754 141.992 118.518 143.006 119.497 142.612V144.951L118.489 145.533V145.91L120.885 144.527V144.15L119.878 144.731V142.391H119.877Z",
    fill: "#F5B500"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M122.19 145.048L117.186 147.937C116.644 148.25 116.203 147.995 116.203 147.369V141.591C116.203 140.965 116.644 140.201 117.186 139.888L122.19 136.999C122.732 136.686 123.174 136.941 123.174 137.567V143.345C123.174 143.971 122.732 144.735 122.19 145.048ZM117.186 140.454C116.914 140.611 116.693 140.994 116.693 141.309V147.086C116.693 147.4 116.915 147.528 117.186 147.371L122.19 144.482C122.463 144.325 122.683 143.942 122.683 143.628V137.85C122.683 137.536 122.462 137.408 122.19 137.565L117.186 140.454Z",
    fill: "#F5B500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.793 60.0142L89.6394 87.8922H88.3599L138.814 60.2402L89.6397 90.109L89 90.4977L88.3592 90.109L38.793 60.0142Z",
    fill: "#F5B500"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3483 133.026L55.746 131.633L52.1166 137.862L49.7188 139.256L53.3483 133.026Z",
    fill: "#F3D35A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.125 128.856L48.5227 127.463L55.7452 131.633L53.3475 133.026L46.125 128.856Z",
    fill: "#F3D35A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3475 133.026L49.718 139.256L46.125 128.856L53.3475 133.026Z",
    fill: "#EBB12A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5354 100.437L36.9332 99.0438L36.9097 107.343L34.5117 108.737L34.5354 100.437Z",
    fill: "#F3D35A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2891 100.417L29.687 99.0234L36.9321 99.0438L34.5343 100.437L27.2891 100.417Z",
    fill: "#F3D35A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5343 100.437L34.5106 108.737L27.2891 100.417L34.5343 100.437Z",
    fill: "#EBB12A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.418 115.163L38.8158 113.769L43.9039 122.582L41.5059 123.976L36.418 115.163Z",
    fill: "#F3D35A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4193 115.163L41.5072 123.976L33.8203 122.5L36.4193 115.163Z",
    fill: "#EBB12A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1055 130.57L65.5032 129.176L68.0523 139.486L65.6543 140.879L63.1055 130.57Z",
    fill: "#F3D35A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9844 133.488L60.3823 132.095L65.5036 129.176L63.1059 130.57L57.9844 133.488Z",
    fill: "#F3D35A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1059 130.57L65.6547 140.879L57.9844 133.488L63.1059 130.57Z",
    fill: "#EBB12A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9258 85.9211L36.3235 84.5276L43.9938 91.9187L41.5959 93.3122L33.9258 85.9211Z",
    fill: "#F3D35A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9258 85.9211L41.5959 93.3122L36.4746 96.2308L33.9258 85.9211Z",
    fill: "#EBB12A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8398 98.001L43.2378 96.6075C45.5362 95.2717 48.7197 95.4604 52.234 97.4893L49.8361 98.8828C46.3217 96.8539 43.1385 96.6651 40.8398 98.001Z",
    fill: "#F3D35A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8358 98.8828C56.8085 102.908 62.4486 112.677 62.4259 120.702C62.4033 128.715 56.7261 131.95 49.7534 127.924C42.7699 123.892 37.1297 114.123 37.1524 106.111C37.1752 98.086 42.8522 94.8508 49.8358 98.8828Z",
    fill: "#EBB12A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1382 127.408L58.7403 128.802C61.008 127.484 62.4149 124.683 62.426 120.702C62.4487 112.678 56.8085 102.909 49.8359 98.8829L52.2339 97.4894C59.2065 101.515 64.8467 111.284 64.824 119.309C64.8126 123.289 63.4059 126.091 61.1382 127.408Z",
    fill: "#F3D35A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 104.3L68.1572 102.907L65.5581 110.244L63.1602 111.637L65.7592 104.3Z",
    fill: "#F3D35A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0703 102.825L60.4683 101.431L68.1554 102.907L65.7574 104.3L58.0703 102.825Z",
    fill: "#F3D35A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7574 104.3L63.1584 111.637L58.0703 102.825L65.7574 104.3Z",
    fill: "#EBB12A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8672 87.5507L52.2651 86.1572L55.8475 96.5509L53.4495 97.9444L49.8672 87.5507Z",
    fill: "#F3D35A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8668 87.5508L53.4491 97.9444L46.2266 93.7744L49.8668 87.5508Z",
    fill: "#EBB12A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0625 118.064L67.4603 116.67L74.682 125.002L72.2843 126.396L65.0625 118.064Z",
    fill: "#F3D35A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0626 118.064L72.2844 126.396L65.0391 126.363L65.0626 118.064Z",
    fill: "#EBB12A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3046_255708",
    x1: 88.5,
    y1: 186.945,
    x2: 88.5,
    y2: 130.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#0047CC",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.1f289abd5ee0eba78873561f1ca80351.svg";
export { ForwardRef as ReactComponent };